<template>
  <DialogComponent
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
    v-loading="portReqProcessing"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">
          New Port Request
        </h1>
        <div class="modal-actions col-2">
          <el-button
            type="primary"
            @click="submitPortRequest"
            v-if="lastNumberGroup"
            >Submit</el-button
          >
          <el-button type="default" @click="cancelOperation"> Cancel</el-button>
        </div>
      </div>
    </div>
    <el-form>
      <el-steps :active="activeStep" finish-status="success">
        <el-step></el-step>
        <el-step></el-step>
        <el-step></el-step>
      </el-steps>
      <div id="step-1" v-if="activeStep == 0" v-loading="processing">
        <el-input
          type="textarea"
          placeholder="Enter Numbers One Per Line"
          v-model="createForm.portNumbers"
          :autosize="{ minRows: 4 }"
        >
        </el-input>
        <div class="button-group">
          <el-button type="default" @click="portAvail">Submit</el-button>
        </div>
      </div>
      <div id="step-2" v-if="activeStep == 1">
        <el-form>
          <div class="button-group">
            <el-button
              icon="el-icon-arrow-left"
              type="default"
              @click="stepBack"
              >Back</el-button
            >
            <el-button
              type="default"
              @click="stepForward"
              v-if="portSummaryData.length"
              >Next <i class="el-icon-arrow-right el-icon-right"></i
            ></el-button>
          </div>
          <h2 class="form-section-header" v-if="portSummaryData.length">
            Portable Number Summary
          </h2>
          <vxe-grid
            v-if="portSummaryData.length"
            class="vxe-table"
            round
            border="inner"
            ref="xGrid"
            height="400px"
            auto-resize
            empty-text="No Data"
            show-overflow="tooltip"
            highlight-hover-row
            :data="
              portSummaryData.filter(
                data =>
                  !search ||
                  data.name.toLowerCase().includes(search.toLowerCase())
              )
            "
            :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
            :loading="tableLoading"
            :columns="tableColumnsSummary"
          />
          <h2 class="form-section-header" v-if="unportableSummary.length">
            Unportable numbers
          </h2>
          <vxe-grid
            v-if="unportableSummary.length"
            class="vxe-table"
            round
            border="inner"
            ref="xGrid"
            height="400px"
            auto-resize
            empty-text="No Data"
            show-overflow="tooltip"
            highlight-hover-row
            :data="
              unportableSummary.filter(
                data =>
                  !search ||
                  data.name.toLowerCase().includes(search.toLowerCase())
              )
            "
            :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
            :loading="tableLoading"
            :columns="tableColumnsSummaryNoPort"
          />
        </el-form>
      </div>
      <div id="step-3" v-show="activeStep == 2" v-loading="processing">
        <el-form>
          <h2 class="form-section-header">
            Current group {{ currentGroupNumber }} / {{ this.csrGroupCount }}
          </h2>
          <div class="group-number-list">
            <vxe-grid
              class="vxe-table"
              round
              border="inner"
              ref="xGrid"
              height="250px"
              auto-resize
              empty-text="No Data"
              show-overflow="tooltip"
              highlight-hover-row
              :data="tableNumbers"
              :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
              :loading="tableLoading"
              :columns="groupTableColumns"
            />
          </div>

          <div class="button-group">
            <el-button
              type="default"
              @click="stepBack"
              v-if="currentGroupNumber === 1"
              >Back to Number Summary
            </el-button>
            <el-button
              type="default"
              @click="stepBack"
              v-if="currentGroupNumber > 1"
              >Prev Group</el-button
            >
            <el-button
              type="default"
              @click="stepForward"
              v-if="!lastNumberGroup"
              >Next Group</el-button
            >
          </div>
          <div
            class="successful-csr-message black-text form-section-header"
            v-if="noResultsGroupActive"
          >
            Automated CSR Lookup Not Available. Use Existing Or Enter Your
            Information.
          </div>
          <div
            class="address-radio-group button-group"
            v-if="noResultsGroupActive"
          >
            <div
              class="radio-button-group"
              v-for="(option, index) in createForm.csrAddressOptions"
              :key="index"
            >
              <el-radio
                class="black-text"
                v-model="createForm.addressRadio"
                :label="index"
                @change="fillAddressFromExisting"
                border
              >
                Use
                {{
                  option.csrLookupResult.endUser +
                    " " +
                    option.csrLookupResult.endUserAddress
                }}
              </el-radio>
            </div>
            <div class="radio-button-group">
              <el-radio
                class="black-text"
                v-model="createForm.addressRadio"
                label="None"
                @change="fillAddressFromExisting"
                v-if="this.createForm.csrAddressOptions.length"
                border
              >
                Enter My Own Info / Clear Fields
              </el-radio>
            </div>
          </div>
          <div
            class="successful-csr-message black-text form-section-header"
            v-if="!noResultsGroupActive"
          >
            Automated CSR lookup was successful. Available data Is populated.
          </div>
          <h2 class="form-section-header">
            Account details
          </h2>
          <div class="inline-form-group">
            <el-col :span="9">
              <el-tooltip
                class="item"
                effect="dark"
                content="This is the person that is authorized to make changes on the account"
                placement="top"
              >
                <el-input
                  v-model="createForm.authorizedPerson"
                  placeholder="Enter authorized person"
                >
                  <template slot="prefix">Authorized person</template>
                </el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="1" />
            <el-col :span="7">
              <el-tooltip
                class="item"
                effect="dark"
                content="Account number is only required if it is displayed on your monthly bill"
                placement="top"
              >
                <el-input
                  v-model="createForm.accountNumber"
                  placeholder="Enter account #"
                >
                  <template slot="prefix">Account #</template>
                </el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="1" />
            <el-col :span="7">
              <el-tooltip
                class="item"
                effect="dark"
                content="Pin number for the account. May not be required"
                placement="top"
              >
                <el-input
                  v-model="createForm.accountPin"
                  placeholder="Enter account pin"
                >
                  <template slot="prefix">Account pin</template>
                </el-input>
              </el-tooltip>
            </el-col>
          </div>
          <div class="inline-form-group">
            <el-col :span="9">
              <el-input
                v-model="createForm.companyName"
                placeholder="Enter company name"
              >
                <template slot="prefix">Company name</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="7">
              <el-input v-model="createForm.atn" placeholder="Enter BTN">
                <template slot="prefix">BTN</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="7">
              <el-date-picker
                v-model="createForm.portDate"
                type="date"
                :default-value="defaultDate()"
                :editable="false"
                :picker-options="datePickerOptions"
                :disabled="this.currentGroupNumber > 1"
                placeholder="Desired port date"
                v-show="this.currentGroupNumber === 1"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </div>
          <h2 class="form-section-header">
            Address
          </h2>
          <el-input
            name="autoAddressCreate"
            v-model="address"
            placeholder="Search for address"
          >
            <template slot="prefix">Search address</template>
          </el-input>
          <div class="address-fields" v-show="addressFieldsActive">
            <div class="inline-form-group">
              <el-col :span="8">
                <el-input
                  v-model="createForm.streetNum"
                  placeholder="Enter street #"
                >
                  <template slot="prefix">Street #</template>
                </el-input>
              </el-col>
              <el-col :span="1" />
              <el-col :span="15">
                <el-input
                  v-model="createForm.streetInfo"
                  placeholder="Enter street name"
                >
                  <template slot="prefix">Street name</template>
                </el-input>
              </el-col>
            </div>
            <div class="inline-form-group">
              <el-col :span="8">
                <el-select
                  v-model="createForm.locationType"
                  placeholder="Select location type"
                >
                  <template slot="prefix">Building / Suite</template>
                  <el-option
                    v-for="(location, index) in locationOptions"
                    :key="index"
                    :label="location"
                    :value="location"
                  />
                </el-select>
              </el-col>
              <el-col :span="1" />
              <el-col :span="15">
                <el-input
                  v-model="createForm.locationNumber"
                  placeholder="Enter building/suite #"
                >
                  <template slot="prefix">Building / suite #</template>
                </el-input>
              </el-col>
            </div>
            <div class="inline-form-group">
              <el-col :span="11">
                <el-input v-model="createForm.city" placeholder="Enter city">
                  <template slot="prefix">City</template>
                </el-input>
              </el-col>
              <el-col :span="1"></el-col>
              <el-col :span="5">
                <el-input v-model="createForm.state" placeholder="Enter state">
                  <template slot="prefix">State</template>
                </el-input>
              </el-col>
              <el-col :span="1"></el-col>
              <el-col :span="6">
                <el-input
                  v-model="createForm.postalCode"
                  placeholder="Enter zip"
                >
                  <template slot="prefix">Zip code</template>
                </el-input>
              </el-col>
            </div>
          </div>
        </el-form>
      </div>
    </el-form>
  </DialogComponent>
</template>

<script>
import { mapActions } from "vuex";

import DialogComponent from "@/components/CustomModalComponent";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "NormalPortRequestForm",

  props: {
    createVisible: { required: true },
    clearFields: { required: true },
    portReqProcessing: { required: true },
    datePickerOptions: { required: true },
    locationOptions: { required: true }
  },

  components: {
    DialogComponent
  },

  data() {
    return {
      activeStep: 0,
      processing: false,

      search: "",
      tableLoading: false,
      portSummaryData: [],
      unportableSummary: [],
      tableNumbers: [],

      currentGroupNumber: 1,
      csrGroupCount: "",
      csrGroups: {},
      currentCsrGroup: {},
      orderValidationFailed: false,
      noResultsGroupActive: false,

      lastNumberGroup: false,

      address: "",
      addressFieldsActive: false,

      orderData: [],
      createForm: {
        portNumbers: "",
        numberArray: [],
        accountNumber: "",
        accountPin: "",
        companyName: "",
        authorizedPerson: "",
        portDate: this.defaultDate(),
        streetNum: "",
        streetInfo: "",
        city: "",
        state: "",
        postalCode: "",
        locationType: "",
        locationNumber: "",
        csrAddressOptions: [],
        addressRadio: "",
        atn: ""
      },

      tableColumnsSummary: [
        { type: "seq", width: 30 },
        {
          field: "telephoneNumber",
          title: "Number",
          minWidth: 150,
          sortable: true,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [<span>{this.numberFormatter(row.telephoneNumber)}</span>];
            }
          }
        },
        {
          field: "serviceProviderName",
          title: "Provider",
          minWidth: 150,
          showOverflow: true,
          sortable: true
        },
        {
          field: "check",
          minWidth: 60,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon">
                  <v-svg class="voxo-green" sprite="check" />
                </div>
              ];
            }
          }
        }
      ],
      tableColumnsSummaryNoPort: [
        { type: "seq", width: 30 },
        {
          field: "telephoneNumber",
          title: "Number",
          minWidth: 150,
          sortable: true,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [<span>{this.numberFormatter(row.telephoneNumber)}</span>];
            }
          }
        },
        {
          field: "notPortableReason",
          title: "Reason",
          minWidth: 150,
          showOverflow: true,
          sortable: true
        },
        {
          field: "cross",
          minWidth: 60,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon">
                  <v-svg class="voxo-red" sprite="cross" />
                </div>
              ];
            }
          }
        }
      ],
      groupTableColumns: [
        {
          field: "number",
          title: "Number",
          minWidth: 150,
          sortable: true,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [<span>{this.numberFormatter(row.number)}</span>];
            }
          }
        }
      ]
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    }
  },

  watch: {
    clearFields: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetFields();
        }
      }
    }
  },

  methods: {
    ...mapActions("number-porting", {
      tnPortAvailability: "find"
    }),

    async submitPortRequest() {
      await this.submitOrderObject(this.createForm);

      if (!this.orderValidationFailed) {
        this.$emit("portRequest", this.orderData);
      }
    },

    cancelOperation() {
      this.$emit("cancelOperation");
    },

    resetFields() {
      Object.keys(this.createForm).forEach(key => {
        if (key === "portDate") {
          this.createForm[key] = this.defaultDate();
          return;
        }

        this.createForm[key] = Array.isArray(this.createForm[key]) ? [] : "";
      });

      this.activeStep = 0;
      this.processing = false;
      this.search = "";
      this.tableLoading = false;
      this.portSummaryData = [];
      this.unportableSummary = [];
      this.tableNumbers = [];
      this.currentGroupNumber = 1;
      this.csrGroupCount = "";
      this.csrGroups = {};
      this.currentCsrGroup = {};
      this.orderValidationFailed = false;
      this.noResultsGroupActive = false;
      this.lastNumberGroup = false;
      this.address = "";
      this.addressFieldsActive = false;
    },

    async submitOrderObject(data) {
      const message = this.lastNumberGroup
        ? "Submit Group and Order with Desired Port Date of " +
          this.createForm.portDate.toDateString() +
          "?"
        : "Submit Number Group For Porting?";
      const successMessage = this.lastNumberGroup
        ? "Port Order Request Created!"
        : "Group Added to Order";

      let group = {
        accountNumber: data.accountNumber,
        accountPin: data.accountPin,
        authorizedPerson: data.authorizedPerson,
        city: data.city,
        companyName: data.companyName,
        location: data.locationType + " " + data.locationNumber,
        numberArray: data.numberArray,
        portDate: data.portDate,
        postalCode: data.postalCode,
        state: data.state,
        streetInfo: data.streetInfo,
        streetNum: data.streetNum,
        atn: data.atn,
        tenantId: this.selectedTenant.id
      };

      await this.$confirm(message, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel"
      })
        .then(async () => {
          //validate the object first and throw error. if good push to order.
          const params = {
            query: { context: "validateOrderObject", formData: group }
          };
          await this.tnPortAvailability(params)
            .then(() => {
              if (!this.lastNumberGroup) {
                this.$notify({
                  title: successMessage,
                  type: "success"
                });
              }
              this.orderValidationFailed = false;
              this.orderData[this.currentGroupNumber - 1] = group;
            })
            .catch(error => {
              this.orderValidationFailed = true;
              this.$notify({
                title: error.name,
                message: error.message,
                type: "error"
              });
            });
        })
        .catch(() => true);
    },

    defaultDate() {
      let checkDate = new Date();
      let dayIncrement = 0;
      let weekend = false;
      while (dayIncrement < 1) {
        weekend = false;
        checkDate.setDate(checkDate.getDate() + 1);
        if (checkDate.getDay() == "0" || checkDate.getDay() == "6") {
          weekend = true;
        }
        if (!weekend) {
          dayIncrement++;
        }
      }
      return checkDate;
    },

    fillAddressFromExisting(index) {
      if (index !== "None") {
        //use csr lookup result if we got one to autofill fields for step 3
        const csr = this.createForm.csrAddressOptions[index].csrLookupResult;

        if (Object.keys(csr).length) {
          this.addressFieldsActive = true;
          //if csr lookup comes back without address components request google place
          if (csr.streetNum == "") {
            this.createForm.accountNumber = csr.accountNum;
            this.createForm.authorizedPerson = csr.authName;
            this.createForm.companyName = csr.endUser;
            const input =
              csr.endUserAddress +
              " " +
              csr.city +
              " " +
              csr.state +
              " " +
              csr.postalCode;
            let placesService = new google.maps.places.PlacesService(
              document.getElementById("places-div")
            );
            placesService.findPlaceFromQuery(
              { query: input, fields: ["place_id"] },
              (results, status) => {
                placesService.getDetails(
                  {
                    placeId: results[0].place_id,
                    fields: ["address_component"]
                  },
                  (result, status) => {
                    if (status == google.maps.places.PlacesServiceStatus.OK) {
                      this.fillAddressFields(result.address_components);
                    }
                  }
                );
              }
            );
          } else {
            this.createForm.accountNumber = csr.accountNum;
            this.createForm.authorizedPerson = csr.authName;
            this.createForm.companyName = csr.endUser;
            this.createForm.streetNum = csr.streetNum;
            this.address = csr.endUserAddress;
            this.createForm.streetInfo =
              csr.streetPreDir + " " + csr.streetName + " " + csr.streetType;
            this.createForm.city = csr.city;
            this.createForm.state = csr.state;
            this.createForm.postalCode = csr.postalCode;
            this.createForm.locationNumber = csr.locationValue1;
            this.createForm.locationType = csr.locationType1;
          }
        }
      } else {
        this.createForm.accountNumber = "";
        this.createForm.authorizedPerson = "";
        this.createForm.companyName = "";
        this.createForm.streetNum = "";
        this.address = "";
        this.createForm.streetInfo = "";
        this.createForm.city = "";
        this.createForm.state = "";
        this.createForm.postalCode = "";
        this.createForm.locationNumber = "";
        this.createForm.locationType = "";
        this.addressFieldsActive = false;
      }
    },

    portAvail() {
      this.processing = true;
      const numberArray = this.createForm.portNumbers.split(/\r?\n/);
      let trimmedNumberArray = [];
      let summaryTableNumbers = [];

      numberArray.forEach((d, index) => {
        numberArray[index] = this.formatNumber(d);
      });
      numberArray.forEach(d => {
        const tollFree = d.match(
          /^(\+?1)?(8(00|33|44|55|66|77|88)[2-9]\d{6})$/g
        );
        if (d != "" && tollFree === null) {
          trimmedNumberArray.push(d);
          summaryTableNumbers.push({ number: d });
        }
      });

      this.createForm.atn = trimmedNumberArray[0];
      this.createForm.numberArray = JSON.stringify(trimmedNumberArray);
      this.tableNumbers = summaryTableNumbers;

      //we will check the api for port availability
      let params = { query: { numbers: this.createForm.numberArray } };
      this.tnPortAvailability(params)
        .then(res => {
          let returnedGroups = res;
          let verifiedGroups = [];

          //in case a no results group is returned with only not portable numbers we don't include as an order group
          for (let i = 0; i < returnedGroups.length; i++) {
            let portableCount = 0;
            for (let k = 0; k < returnedGroups[i]["numbers"].length; k++) {
              if (returnedGroups[i]["numbers"][k].isPortable) {
                portableCount++;
              }
            }
            if (portableCount) {
              verifiedGroups.push(returnedGroups[i]);
            }
          }
          this.csrGroups = verifiedGroups;

          //check available csrlookup options to provide to user for no result group.
          const csrGroupCount = (this.csrGroupCount = verifiedGroups.length);
          let csrAddressOptions = [];
          for (let i = 0; i < csrGroupCount; i++) {
            if (res[i]["csrGroup"] !== "noResult") {
              let groupObject = {
                csrLookupResult: JSON.parse(res[i]["csrGroup"]),
                id: res[i]["id"]
              };
              csrAddressOptions.push(groupObject);
            }
          }
          this.createForm.csrAddressOptions = csrAddressOptions;

          //build the port summary tables
          this.processing = false;
          let portableNumbers = [];
          let notPortable = [];
          let portableNumberArray = [];

          for (let i = 0; i < res.length; i++) {
            for (let k = 0; k < res[i]["numbers"].length; k++) {
              if (!res[i]["numbers"][k].isPortable) {
                notPortable.push(res[i]["numbers"][k]);
              } else {
                portableNumbers.push(res[i]["numbers"][k]);
                portableNumberArray.push(res[i]["numbers"][k].telephoneNumber);
              }
            }
          }
          this.portSummaryData = portableNumbers;
          this.unportableSummary = notPortable;
          //clear list to avoid storing old results
          this.$store.commit("number-porting/clearList");
          if (this.activeStep++ > 2) this.active = 2;
        })
        .catch(error => {
          console.log(error);
          this.$notify({
            title: error.name,
            message: error.message,
            type: "error"
          });
          this.processing = false;
        });
    },

    fillAddressFromCSR() {
      //use csr lookup result if we got one to autofill fields for step 3
      const csr = JSON.parse(this.currentCsrGroup.csrGroup);

      if (Object.keys(csr).length) {
        this.addressFieldsActive = true;
        //if csr lookup comes back without address components request google place
        if (csr.streetNum == "") {
          this.createForm.accountNumber = csr.accountNum;
          this.createForm.authorizedPerson = csr.authName;
          this.createForm.companyName = csr.endUser;
          const input =
            csr.endUserAddress +
            " " +
            csr.city +
            " " +
            csr.state +
            " " +
            csr.postalCode;
          let placesService = new google.maps.places.PlacesService(
            document.getElementById("places-div")
          );
          placesService.findPlaceFromQuery(
            { query: input, fields: ["place_id"] },
            (results, status) => {
              placesService.getDetails(
                {
                  placeId: results[0].place_id,
                  fields: ["address_component"]
                },
                (result, status) => {
                  if (status == google.maps.places.PlacesServiceStatus.OK) {
                    this.fillAddressFields(result.address_components);
                  }
                }
              );
            }
          );
        } else {
          this.createForm.accountNumber = csr.accountNum;
          this.createForm.authorizedPerson = csr.authName;
          this.createForm.companyName = csr.endUser;
          this.createForm.streetNum = csr.streetNum;
          this.address = csr.endUserAddress;
          this.createForm.streetInfo =
            csr.streetPreDir + " " + csr.streetName + " " + csr.streetType;
          this.createForm.city = csr.city;
          this.createForm.state = csr.state;
          this.createForm.postalCode = csr.postalCode;
          this.createForm.locationNumber = csr.locationValue1;
          this.createForm.locationType = csr.locationType1;
        }
      }
    },

    fillAddressFields(data) {
      let locationInfo = {
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        administrative_area_level_1: "short_name",
        postal_code: "short_name"
      };

      let locationObject = {
        street_number: "",
        route: "",
        locality: "",
        administrative_area_level_1: "",
        postal_code: ""
      };

      for (let i = 0; i < data.length; i++) {
        let addressType = data[i].types[0];
        if (locationInfo[addressType]) {
          locationObject[addressType] = data[i][locationInfo[addressType]];
        }
      }

      //here we will update our address object sent with the request
      this.createForm.streetNum = locationObject["street_number"];
      this.createForm.streetInfo = locationObject["route"];
      this.createForm.city = locationObject["locality"];
      this.createForm.state = locationObject["administrative_area_level_1"];
      this.createForm.postalCode = locationObject["postal_code"];
      this.address =
        locationObject["street_number"] +
        " " +
        locationObject["route"] +
        " " +
        locationObject["locality"] +
        ", " +
        locationObject["administrative_area_level_1"] +
        " " +
        locationObject["postal_code"];
      this.addressFieldsActive = true;
    },

    stepBack() {
      this.lastNumberGroup = false;
      this.createForm.addressRadio = "";
      if (this.activeStep === 2 && this.currentGroupNumber === 1) {
        if (this.activeStep-- < 0) this.activeStep = 0;
      } else if (this.activeStep === 1) {
        //this will just take us back to the submit numbers step 1
        if (this.activeStep-- < 0) this.activeStep = 0;
      } else {
        //this will step back through the number groups
        if (this.currentGroupNumber === this.csrGroups.length) {
          delete this.orderData[this.currentGroupNumber - 1];
        }

        this.currentGroupNumber--;
        //fill out account fields with existing order info already submitted
        const groupOrderData = this.orderData[this.currentGroupNumber - 1];
        this.createForm.accountNumber = groupOrderData.accountNumber;
        this.createForm.authorizedPerson = groupOrderData.authorizedPerson;
        this.createForm.companyName = groupOrderData.companyName;
        this.createForm.streetNum = groupOrderData.streetNum;
        this.address =
          groupOrderData.streetNum +
          " " +
          groupOrderData.streetInfo +
          " " +
          groupOrderData.city +
          ", " +
          groupOrderData.state +
          " " +
          groupOrderData.postalCode;
        this.createForm.streetInfo = groupOrderData.streetInfo;
        this.createForm.city = groupOrderData.city;
        this.createForm.state = groupOrderData.state;
        this.createForm.postalCode = groupOrderData.postalCode;
        this.createForm.locationNumber = groupOrderData.location.split(" ")[1];
        this.createForm.locationType = groupOrderData.location.split(" ")[0];
        delete this.orderData[this.currentGroupNumber - 1];
        this.currentCsrGroup = this.csrGroups[this.currentGroupNumber - 1];

        if (this.currentCsrGroup.csrGroup === "noResult") {
          this.noResultsGroupActive = true;
        } else {
          this.noResultsGroupActive = false;
        }

        this.createForm.numberArray = [];
        this.currentCsrGroup.numbers.forEach(n => {
          if (n.isPortable) {
            this.createForm.numberArray.push(n.telephoneNumber);
          }
        });
      }
    },

    async stepForward() {
      this.activeStep++;

      //can't go further than step 2
      if (this.activeStep - 1 >= 2) {
        this.activeStep = 2;
        await this.submitOrderObject(this.createForm);
        //console.log(this.orderValidationFailed);
        //if group passed validation we can continue
        if (!this.orderValidationFailed) {
          this.currentGroupNumber++;
          //clear applicable form fields
          this.addressFieldsActive = false;
          this.createForm.authorizedPerson = "";
          this.createForm.accountNumber = "";
          this.createForm.companyName = "";
          this.address = "";
          this.createForm.streetInfo = "";
          this.createForm.streetNum = "";
          this.createForm.locationType = "";
          this.createForm.locationNumber = "";
          this.createForm.city = "";
          this.createForm.state = "";
          this.createForm.postalCode = "";
          this.createForm.addressRadio = "";
        }
      }

      //if we are on the final group of numbers we will not show a next button and show the submit!
      if (this.currentGroupNumber === this.csrGroupCount) {
        this.lastNumberGroup = true;
      }

      //set the current csr group object and activate checkboxes if its the 'no results' group
      this.currentCsrGroup = this.csrGroups[this.currentGroupNumber - 1];
      if (this.currentCsrGroup.csrGroup === "noResult") {
        this.noResultsGroupActive = true;
      } else {
        this.noResultsGroupActive = false;
        //fill in the form fields since the group has results
        this.fillAddressFromCSR();
      }

      this.createForm.numberArray = [];
      this.currentCsrGroup.numbers.forEach(n => {
        if (n.isPortable) {
          this.createForm.numberArray.push(n.telephoneNumber);
        }
      });
    },

    formatNumber(number) {
      let formattedNumber = number
        .replace(/[&\/\\#,+()$~%.'":*?<>{}-]/g, "")
        .replace(/ /g, "");
      if (formattedNumber.charAt(0) == "1") {
        formattedNumber = formattedNumber.substr(1);
      }
      return formattedNumber;
    },

    numberFormatter(val) {
      return val ? phoneNumberFormatter(val) : val;
    }
  },

  mounted() {
    // ⭐️ Google Autocomplete ⭐️ //
    this.autocomplete = new google.maps.places.Autocomplete(
      document.querySelector("input[name='autoAddressCreate']"),
      { types: ["geocode"] }
    );
    this.autocomplete.setFields(["address_components"]);
    this.autocomplete.setComponentRestrictions({
      country: ["us", "vi", "ca"]
    });
    this.autocomplete.addListener("place_changed", () => {
      let place = this.autocomplete.getPlace();
      let ac = place.address_components;
      this.fillAddressFields(ac, "create");
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.el-steps {
  width: 300px;
  margin: auto;
  margin-bottom: 20px;
}

.button-group {
  max-width: 600px;
  margin: 30px auto;
}

.group-number-list {
  max-width: 600px;
  margin: 10px auto;
}

.radio-button-group {
  margin: 5px 0;
}

.form-comment-header,
.order-note,
.order-notes {
  max-width: 600px;
  margin: 5px auto;
  font: {
    size: 11pt;
  }
}

.order-note {
  margin-top: 15px;
}

.vxe-table,
.attach-docs {
  max-width: 600px;
  margin: 0 auto;
}

.notes-container {
  margin-top: 10px;
  max-height: 250px;
  overflow: auto;
  border: 1px solid #dcdfe6;
  padding: 5px 10px;
}

.number-check-group {
  display: flex;
  flex-wrap: wrap;

  > * {
    flex-basis: 50%;
    margin: 2px 0;
  }

  max-width: 600px;
  margin: auto;
}

.check-all {
  padding-left: 15px;
}
</style>
